import webApiAdmin from '@/lib/api-common/webApiAdmin';

export interface Organization {
  _id: string;
  name: string;
}

/**
 * List organizations the admin can switch to.
 * - POST /admin/organizations/load
 */
export async function loadOrganizations(): Promise<Organization[]> {
  const data = await webApiAdmin.post<Organization[]>('admin/organizations/load', {});
  return Array.isArray(data) ? data : [];
}

/**
 * Switch the active organization.
 * - POST /admin/organizations/switch
 */
export async function switchOrganization(organizationId: string): Promise<void> {
  await webApiAdmin.post('admin/organizations/switch', { organizationId });
}
